// extracted by mini-css-extract-plugin
export default {"ace-c-damage-description-info-panel__damage-description":"damage-description-info-panel__damage-description---eb239029"};